import { lazy } from 'react'

const PlanningModule = lazy(async () => {
  const { Planning } = await import(/* webpackChunkName: "planning-goals" */ './')

  return {
    default: Planning
  }
})
const PlanningAssignment = lazy(async () => {
  const { PlanningAssignments } = await import(
    /* webpackChunkName: "planning-assignment" */ './assignments'
  )

  return {
    default: PlanningAssignments
  }
})
const routes = [
  {
    path: '/planning/assignments',
    name: 'Assignments',
    authenticated: true,
    render(props) {
      return <PlanningAssignment {...props} />
    }
  },
  {
    path: '/planning/goal',
    name: 'Goals and Planning',
    authenticated: true,
    render(props) {
      return <PlanningModule {...props} />
    }
  }
]

export { routes }
